import React, { useEffect, useState } from "react";

import "./stylesLatestBetsList.css";

import createPrivateAdminPanelInstance from "../../../../api/PrivateAdminPanelInstance";
import { API_ROUTES } from "../../../../api/ApiRoutes";

import RebetLoader from "../../../CommonComponents/RebetLoader/RebetLoader";

import dayjs from "dayjs";
import { ChevronDown, ChevronUp, Filter } from "react-feather";
import { Pagination, Select, message } from "antd";
import CustomAutoCompleteControlled from "../../../CommonComponents/CustomAutoComplete/CustomAutoCompleteControlled";
import DragAndDropTable from "./DragAndDropTable/DragAndDropTable";
import { DragOutlined, FullscreenOutlined } from "@ant-design/icons";
import { Popover } from "antd";
import { useSearchParams } from "react-router-dom";

const initialColumnsState = [
  {
    title: "Provider",
    dataIndex: "odds_provider",
    key: "odds_provider",
    initialWidth: 150,
    columnIndex: 0,
  },
  {
    title: "CCF",
    dataIndex: "ccf_score",
    key: "ccf_score",
    initialWidth: 80,
    columnIndex: 1,
  },
  {
    title: "ID",
    dataIndex: "bet_id",
    key: "bet_id",
    initialWidth: 100,
    columnIndex: 2,
  },
  {
    title: "User ID",
    dataIndex: "user_id",
    key: "user_id",
    initialWidth: 100,
    columnIndex: 3,
  },
  {
    title: "Date",
    dataIndex: "date_time",
    key: "date_time",
    initialWidth: 150,
    columnIndex: 4,
  },
  {
    title: "Market",
    dataIndex: "market_names",
    key: "market_names",
    initialWidth: 200,
    columnIndex: 7,
  },
  {
    title: "Selection",
    dataIndex: "selection_names",
    key: "selection_names",
    initialWidth: 200,
    columnIndex: 8,
  },
  {
    title: "Odds",
    dataIndex: "odds",
    key: "odds",
    initialWidth: 200,
    columnIndex: 9,
  },
  {
    title: "Bet Type",
    dataIndex: "bet_type",
    key: "bet_type",
    initialWidth: 200,
    columnIndex: 10,
  },
  {
    title: "Live",
    dataIndex: "preMatchLive",
    key: "preMatchLive",
    initialWidth: 200,
    columnIndex: 11,
  },
  {
    title: "Bet Amount",
    dataIndex: "bet_amount",
    key: "bet_amount",
    initialWidth: 200,
    columnIndex: 12,
  },
  {
    title: "Status",
    dataIndex: "status",
    key: "status",
    initialWidth: 200,
    columnIndex: 13,
  },
  {
    title: "Potential Payout",
    dataIndex: "payout",
    key: "payout",
    initialWidth: 200,
    columnIndex: 14,
  },
];

function LatestBetsList() {
  const token = JSON.parse(localStorage.getItem("token"));
  const PrivateAdminPanelInstance = createPrivateAdminPanelInstance(
    token?.IdToken,
    false
  );
  const columnsState =
    JSON.parse(
      localStorage.getItem("columnsStateEventDetailsLatestBetsList")
    ) || initialColumnsState;
  const todayRange = [dayjs(), dayjs()];

  const [searchParams] = useSearchParams();
  const eventId = searchParams.get("event-id");

  const [messageApi, contextHolder] = message.useMessage();

  const [isApiRunning, setIsApiRunning] = useState(false);
  const [showExtraFilters, setShowExtraFilters] = useState(false);

  const [filtersApplied, setFiltersApplied] = useState(false);
  const [betsCache, setBetsCache] = useState({});

  const [selectedOddProvider, setSelectedOddProvider] = useState(null);
  const [selectedMinBetAmount, setSelectedMinBetAmount] = useState(null);
  const [selectedBetType, setSelectedBetType] = useState(null);
  const [selectedStatus, setSelectedStatus] = useState(null);
  const [selectedMarketType, setSelectedMarketType] = useState(null);
  const [selectedMinCCF, setSelectedMinCCF] = useState(null);
  const [selectedMaxCCF, setSelectedMaxCCF] = useState(null);
  const [selectedPreMatchLive, setSelectedPreMatchLive] = useState(null);
  const [selectedMoneyType, setSelectedMoneyType] = useState(null);

  const columns = columnsState;

  const [modeState, setModeState] = useState("resize");

  const [expandedKeys, setExpandedKeys] = useState([]);
  const [marketTypes, setMarketTypes] = useState([]);
  const [minCCF, setMinCCF] = useState([]);
  const [maxCCF, setMaxCCF] = useState([]);
  const [statuses, setStatuses] = useState([
    {
      value: "cancelled",
      label: "Cancelled",
    },
    {
      value: "finalized",
      label: "Finalized",
    },
  ]);
  const [oddsProviders, setOddsProviders] = useState([
    {
      value: null,
      label: "All",
    },
    {
      value: "sportradar",
      label: "Sportradar",
    },
    {
      value: "Oddin",
      label: "Oddin",
    },
    {
      value: "dst",
      label: "DST",
    },
  ]);
  const preMatchLive = [
    {
      value: "live",
      label: "Live",
    },
    {
      value: "prematch",
      label: "Pre-match",
    },
  ];

  const betTypes = [
    {
      value: "single",
      label: "Straight",
    },
    {
      value: "round_robin_leg",
      label: "Round Robin",
    },
    {
      value: "grouped_leg",
      label: "Group",
    },
    {
      value: "parlay",
      label: "Parlay",
    },
  ];
  const moneyTypes = [
    {
      value: null,
      label: "All",
    },
    {
      value: "rebet_cash",
      label: "Cash",
    },
    {
      value: "rebet_coin",
      label: "Coin",
    },
    {
      value: "rebet_free_cash",
      label: "Free Cash",
    },
  ];

  const [betsToShowInTable, setBetsToShowInTable] = useState([]);
  const [pagination, setPagination] = useState({
    total: 0,
    page: 1,
    pageSize: 10,
  });

  const getBetsReport = async (page = 1, refresh = false) => {
    const cacheKey = page;

    if (betsCache[cacheKey] && !refresh) {
      const cached = betsCache[cacheKey];
      setBetsToShowInTable(cached.bets);
      setPagination(cached.pagination);
      return;
    }

    try {
      setIsApiRunning(true);

      const payload = {
        event_id: eventId,
        page: page,
        ...(selectedMinBetAmount && { min_bet_amount: selectedMinBetAmount }),
        ...(selectedBetType && { bet_type: selectedBetType }),
        ...(selectedMarketType && { market_type: selectedMarketType }),
        ...(selectedMinCCF && { min_ccf: selectedMinCCF }),
        ...(selectedMaxCCF && { max_ccf: selectedMaxCCF }),
        ...(selectedOddProvider && { odds_provider: selectedOddProvider }),
        ...(selectedStatus && { status: selectedStatus }),
        ...(selectedPreMatchLive && { pre_match_live: selectedPreMatchLive }),
        ...(selectedMoneyType && { money_type: selectedMoneyType }),
      };

      console.log("payload", payload);
      const requests = [
        PrivateAdminPanelInstance?.post(
          API_ROUTES?.GET_EVENT_DETAILS_TABLE,
          payload
        ),
        PrivateAdminPanelInstance?.post(API_ROUTES?.GET_EVENT_MARKETS, {
          event_id: eventId,
        }),
      ];
      const responses = await Promise.allSettled(requests);

      const [eventDetailsTableResponse, eventMarketsResponse] = responses;
      console.log("eventDetailsTableResponse", eventDetailsTableResponse);
      console.log("eventMarketsResponse", eventMarketsResponse);

      if (eventMarketsResponse.status === "fulfilled") {
        const data =
          eventMarketsResponse?.value?.data?.data?.market_types || [];
        const marketTypes = data.map((market) => {
          return {
            value: market.market_name,
            label: market.market_name,
          };
        });
        setMarketTypes(marketTypes);
      }

      if (eventDetailsTableResponse.status === "fulfilled") {
        const data = eventDetailsTableResponse?.value?.data?.data;
        let bets = data.bets;
        console.log("bets", bets);
        const pagination = data.pagination;
        setBetsToShowInTable(bets);
        setPagination(pagination);
        setBetsCache((prev) => ({
          ...prev,
          [cacheKey]: { bets, pagination },
        }));
      }
    } catch (error) {
      console.log("Error getting bets report:", error);
    } finally {
      setIsApiRunning(false);
    }
  };

  const handleBetTypeChange = (value) => {
    setSelectedBetType(value);
  };

  const handleBetAmountChange = (value) => {
    setSelectedMinBetAmount(value);
  };

  const handleOddProviderChange = (value) => {
    setSelectedOddProvider(value);
  };

  const handleStatusChange = (value) => {
    setSelectedStatus(value);
  };

  const handlePreMatchLiveChange = (value) => {
    setSelectedPreMatchLive(value);
  };

  const handleMarketTypeChange = (value) => {
    setSelectedMarketType(value);
  };

  const handleMinCCFChange = (value) => {
    setSelectedMinCCF(value);
  };

  const handleMaxCCFChange = (value) => {
    setSelectedMaxCCF(value);
  };

  const handleMoneyTypeChange = (value) => {
    setSelectedMoneyType(value);
  };

  const handleClearFilters = () => {
    setSelectedBetType(null);
    setSelectedMinBetAmount(null);
    setSelectedOddProvider(null);
    setSelectedStatus(null);
    setSelectedPreMatchLive(null);
    setSelectedMarketType(null);
    setSelectedMinCCF(null);
    setSelectedMaxCCF(null);
    setSelectedMoneyType(null);
    setFiltersApplied(false);
    message.success("Filters cleared.");
  };

  const handleApplyFilters = () => {
    setFiltersApplied(true);
    getBetsReport(1, true);
    message.success("Filters applied.");
  };

  const handlePaginationChange = (page) => {
    getBetsReport(page, false);
  };

  useEffect(() => {
    getBetsReport(1, true);
  }, []);

  return (
    <div className="event-details-latest-bets-list-container">
      <div className="event-details-latest-bets-list">
        {contextHolder}
        <>
          <div className="event-details-latest-bets-list-content">
            <div className="event-details-latest-bets-list-autocomplete-container">
              <div
                className="filter-buttons"
                onClick={() => setShowExtraFilters(!showExtraFilters)}
              >
                <Filter className="filter-icon" />
                {showExtraFilters ? (
                  <ChevronUp className="filter-icon" />
                ) : (
                  <ChevronDown className="filter-icon" />
                )}
              </div>
            </div>

            <div
              className="event-details-latest-bets-list-selectors"
              style={{ display: showExtraFilters ? "flex" : "none" }}
            >
              <div className="event-details-latest-bets-list-selector">
                <span>Min Bet Amount</span>
                <CustomAutoCompleteControlled
                  placeholder="Not Selected"
                  value={selectedMinBetAmount}
                  handleChange={(value) => handleBetAmountChange(value)}
                  allOptions={[]}
                  clearOptions={() => handleBetAmountChange(null)}
                  selector="value"
                />
              </div>
              <div className="event-details-latest-bets-list-selector">
                <span>Bet Type</span>
                <Select
                  placeholder="Not Selected"
                  value={selectedBetType}
                  onChange={(value) => handleBetTypeChange(value)}
                  options={betTypes}
                />
              </div>
              <div className="event-details-latest-bets-list-selector">
                <span>Market Type</span>
                <CustomAutoCompleteControlled
                  placeholder="Not Selected"
                  value={selectedMarketType}
                  handleChange={(value) => handleMarketTypeChange(value)}
                  allOptions={marketTypes}
                  clearOptions={() => handleMarketTypeChange(null)}
                  selector="value"
                />
              </div>
              <div className="event-details-latest-bets-list-selector">
                <span>Min CCF</span>
                <CustomAutoCompleteControlled
                  placeholder="Not Selected"
                  value={selectedMinCCF}
                  handleChange={(value) => handleMinCCFChange(value)}
                  clearOptions={() => handleMinCCFChange(null)}
                  allOptions={minCCF}
                  selector="value"
                />
              </div>
              <div className="event-details-latest-bets-list-selector">
                <span>Max CCF</span>
                <CustomAutoCompleteControlled
                  placeholder="Not Selected"
                  value={selectedMaxCCF}
                  handleChange={(value) => handleMaxCCFChange(value)}
                  clearOptions={() => handleMaxCCFChange(null)}
                  allOptions={maxCCF}
                  selector="value"
                />
              </div>
              <div className="event-details-latest-bets-list-selector">
                <span>Odds Provider</span>
                <Select
                  placeholder="Not Selected"
                  value={selectedOddProvider}
                  onChange={(value) => handleOddProviderChange(value)}
                  options={oddsProviders}
                />
              </div>
              <div className="event-details-latest-bets-list-selector">
                <span>Status</span>
                <Select
                  placeholder="Not Selected"
                  value={selectedStatus}
                  onChange={(value) => handleStatusChange(value)}
                  options={statuses}
                />
              </div>
              <div className="event-details-latest-bets-list-selector">
                <span>Pre-match/Live</span>
                <Select
                  placeholder="Not Selected"
                  value={selectedPreMatchLive}
                  onChange={(value) => handlePreMatchLiveChange(value)}
                  options={preMatchLive}
                />
              </div>
              <div className="event-details-latest-bets-list-selector">
                <span>Money Type</span>
                <Select
                  placeholder="Not Selected"
                  value={selectedMoneyType}
                  onChange={(value) => handleMoneyTypeChange(value)}
                  options={moneyTypes}
                />
              </div>
            </div>

            {showExtraFilters && (
              <div className="drag-resize-buttons-container">
                <Popover content="Resize Mode">
                  <button
                    className={modeState === "resize" ? "active" : null}
                    onClick={() => setModeState("resize")}
                  >
                    <FullscreenOutlined />
                  </button>
                </Popover>
                <Popover content="Drag Mode">
                  <button
                    className={modeState === "drag" ? "active" : null}
                    onClick={() => setModeState("drag")}
                  >
                    <DragOutlined />
                  </button>
                </Popover>
              </div>
            )}
            {showExtraFilters && (
              <div className="event-details-latest-bets-list-selector-action-buttons">
                <button className="clear" onClick={() => handleClearFilters()}>
                  Clear Filters
                </button>
                <button className="apply" onClick={() => handleApplyFilters()}>
                  Apply
                </button>
              </div>
            )}
            {isApiRunning ? (
              <RebetLoader height={"100px"} width={"100px"} />
            ) : (
              <div className="event-details-latest-bets-list-kpis-table">
                <DragAndDropTable
                  columns={columns}
                  data={betsToShowInTable}
                  mode={modeState}
                />
                <div className="bets-types-list-pagination-container">
                  <Pagination
                    current={pagination.current_page}
                    total={pagination.total_results}
                    pageSize={pagination.page_size}
                    showSizeChanger={false}
                    onChange={(page) => {
                      if (
                        page === pagination.current_page - 1 ||
                        page === pagination.current_page + 1
                      ) {
                        handlePaginationChange(page);
                      }
                    }}
                    itemRender={(page, type, originalElement) => {
                      if (type === "page") {
                        return (
                          <a
                            rel="nofollow"
                            disabled={page > pagination.current_page + 1}
                            className={`${
                              page > pagination.current_page + 1
                                ? "disabled"
                                : ""
                            }`}
                          >
                            {page}
                          </a>
                        );
                      }
                      return originalElement;
                    }}
                  />
                </div>
              </div>
            )}
          </div>
        </>
      </div>
    </div>
  );
}

export default LatestBetsList;
